import TextAddress from 'src/components/common/formFields/textAddress/TextAddress';
import { componentSizeVariantsEnum } from 'src/constants';
import Label from 'src/components/common/formFields/label/Label';

import './previewField.scss';
import { TPreviewFieldProps } from './previewField.types';

const Address = ({ id, label, hasCharacterLimit, validations, required, createProgramStep }: TPreviewFieldProps) => {
  return (
    <div key={id} className="dynamic-field">
      <Label required={required}>{label}</Label>
      <div className="custom-application-form__form__row__fields__field_view">
        {' '}
        <TextAddress
          id={id}
          variant={componentSizeVariantsEnum.SMALL}
          placeholder={label}
          disabled
          {...(hasCharacterLimit && { textLengthLimit: validations.maxCharacters })}
          createProgramStep
        />
      </div>
    </div>
  );
};

export default Address;
